import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/auth'
import "firebase/performance";
import "firebase/firestore";


// Initialize Firebase
var config = {
  apiKey: "AIzaSyCm2vOHpfmHPJr0Hmrwqf4PHs5oWqboi2Y",
  authDomain: "evotik.firebaseapp.com",
  databaseURL: "https://evotik-default-rtdb.firebaseio.com",
  projectId: "evotik",
  storageBucket: "evotik.appspot.com",
  messagingSenderId: "1009925463430",
  appId: "1:1009925463430:web:587d1a5ecbb032d1436007",
  measurementId: "G-LQ67F3LERN"
};
firebase.initializeApp(config);

const db = firebase.database();
const store = firebase.firestore();
const auth = firebase.auth();
const storageRef = firebase.storage().ref();
const perf = firebase.performance();

export {
  firebase,
  db,
  auth,
  store,
  perf,
  storageRef
};
